import React from 'react';
import { Users, TrendingDown, Clock, DollarSign } from 'lucide-react';
import ImageSlider from './ImageSlider';

const ValuePropositionSection = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Practice Dashboard: Add-On That Replaces{' '}
            <span className="text-blue-600">1 Full-Time Admin Employee</span>
          </h2>
          
          <p className="text-lg sm:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            You likely have an admin pulling and tweaking reports from Practice CS—or maybe you're doing it yourself. 
            Practice Dashboard automates that workload, helping you escape this trap.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div className="space-y-6 sm:space-y-8 order-2 lg:order-1">
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="bg-red-100 rounded-full p-2 sm:p-3 flex-shrink-0">
                <Users className="w-5 h-5 sm:w-6 sm:h-6 text-red-600" />
              </div>
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2">Manual Admin Work</h3>
                <p className="text-base sm:text-lg text-gray-600">Hours spent pulling reports, manual data entry, and repetitive tasks</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="bg-red-100 rounded-full p-2 sm:p-3 flex-shrink-0">
                <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-red-600" />
              </div>
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2">Time Consuming</h3>
                <p className="text-base sm:text-lg text-gray-600">Delayed reports and manual updates that slow down decision making</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="bg-red-100 rounded-full p-2 sm:p-3 flex-shrink-0">
                <DollarSign className="w-5 h-5 sm:w-6 sm:h-6 text-red-600" />
              </div>
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2">High Cost</h3>
                <p className="text-base sm:text-lg text-gray-600">Full-time admin salary plus overhead costs for manual processes</p>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-lg p-4 sm:p-6">
              <div className="text-center mb-4">
                <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-3 mb-4">
                  <TrendingDown className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" />
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900">Practice Dashboard Solution</h3>
                </div>
                
                <div className="space-y-2 sm:space-y-3 text-left">
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2 flex-shrink-0"></div>
                    <span className="text-base sm:text-lg text-gray-700">Eliminates manual report generation</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2 flex-shrink-0"></div>
                    <span className="text-base sm:text-lg text-gray-700">Real-time data updates</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2 flex-shrink-0"></div>
                    <span className="text-base sm:text-lg text-gray-700">Saves 40+ hours per week</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2 flex-shrink-0"></div>
                    <span className="text-base sm:text-lg text-gray-700">Reduces admin overhead by 80%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative order-1 lg:order-2">
            <ImageSlider />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;